const LOCAL_DOMAIN = "localhost.docbox.sankuai.com";

let supportWebSocket = function () {
  return !!window.WebSocket;
};

let __connect = function (url, exist_socket) {
  return new Promise((resolve, reject) => {
    if (exist_socket && exist_socket.readyState === WebSocket.OPEN) {
      return resolve(exist_socket);
    }
    let timeout = 500;
    let conn_timeout = setTimeout(function () {
      reject("error")
    }, timeout);

    // 是否支持websocket
    if (!supportWebSocket()) {
      throw "当前浏览器不支持websocket";
    }

    try {
      // 建立链接
      let server_socket = new WebSocket(url);
      // 连接建立成功
      server_socket.onopen = function (_event) {
        clearTimeout(conn_timeout);
        resolve(server_socket);
      };

      //连接关闭
      server_socket.onclose = function (_event) {
        console.log("channel closed");
      };

      // 连接出错
      server_socket.onerror = function (e) {
        clearTimeout(conn_timeout);
        reject(e);
      };
    } catch (error) {
      clearTimeout(conn_timeout);
      reject(error);
    }
  });
};

let __close = function (server_socket) {
  if (!server_socket) {
    throw 'socket server is null';
  }
  // 关闭
  if (server_socket) {
    server_socket.close();
  }
};

let __send = function (server_socket, msg) {
  if (!server_socket) {
    throw 'socket server is null';
  }

  // 发送消息到客户端
  if (server_socket.readyState !== WebSocket.OPEN) {
    throw 'socket server is not open';
  }
  server_socket.send(msg);
};

let SendMessage = function (message) {
  return new Promise(async (resolve, reject) => {
    let retries = 2;
    let server_socket = null;

    // 主端口
    for (let i = 0; i < retries; i++) {
      if (server_socket && server_socket.readyState === WebSocket.OPEN) {
        break;
      }
      try {
        // 主端口
        let url = `wss://${LOCAL_DOMAIN}:17359`;
        server_socket = await __connect(url, server_socket);
      } catch (e) {
        console.log(e);
      }
    }

    // 备用端口
    for (let i = 0; i < retries; i++) {
      if (server_socket && server_socket.readyState === WebSocket.OPEN) {
        break;
      }
      try {
        // 主端口
        let url = `wss://${LOCAL_DOMAIN}:36892`;
        server_socket = await __connect(url, server_socket);
      } catch (e) {
        console.log(e);
      }
    }

    // websocket客户端
    if (!server_socket || server_socket.readyState !== WebSocket.OPEN) {
      return reject("客户端连接失败");
    }

    let send_timeout;
    // 接收到消息
    server_socket.onmessage = function (event) {
      clearTimeout(send_timeout);
      __close(server_socket);
      return resolve(event.data);
    };

    try {
      // 发送消息到客户端
      __send(server_socket, JSON.stringify(message));
      // 添加发送消息超时
      send_timeout = setTimeout(function () {
        return reject("发送消息超时");
      }, 1000);

    } catch (error) {
      return reject("发送消息失败" + error);
    }
  });
};

export default SendMessage;
